//Calculates the event's time if it has overtime

import { MatchStatus } from '../enums/matchStatus';
import getPeriodLengthFromMatchTime from '../components/MatchWatch/helpers/getPeriodLengthFromMatchTime';
import getExtraTimePeriodLengthFromMatchLength from '../components/MatchWatch/helpers/getExtraTimePeriodLengthFromMatchLength';
import { Match } from '../interfaces/match';

// This function is not safe to use for existing matchEvent, only new ones. That is because match status might differ from the event's period
export default function (overtime: number, match: Match, time: number): number {
  if (match.matchStatusId === MatchStatus.FIRST_HALF) {
    return getPeriodLengthFromMatchTime(match.matchLength);
  } else if (match.matchStatusId === MatchStatus.SECOND_HALF) {
    return getPeriodLengthFromMatchTime(match.matchLength) * 2;
  } else if (match.matchStatusId === MatchStatus.FIRST_HALF_EXTRA_TIME) {
    return (
      getPeriodLengthFromMatchTime(match.matchLength) * 2 + getExtraTimePeriodLengthFromMatchLength(match.matchLength)
    );
  } else if (match.matchStatusId === MatchStatus.SECOND_HALF_EXTRA_TIME) {
    return (
      getPeriodLengthFromMatchTime(match.matchLength) * 2 +
      getExtraTimePeriodLengthFromMatchLength(match.matchLength) * 2
    );
  }
  return time;
}
